<template>
    <div class="col-12">
        <div id="datos_user_block">
            <div class="info_block">
                <div class="content_area">
                    <div class="icon">
                        <div>
                            <svg width="36" height="37" focusable="false" fill="currentColor" viewBox="0 0 32 32" aria-hidden="true">
                                <defs></defs>
                                <g>
                                    <path d="M16 15a6 6 0 1 0-6-6 6 6 0 0 0 6 6zm0-10.5A4.5 4.5 0 1 1 11.5 9 4.5 4.5 0 0 1 16 4.5zM16 16A12 12 0 0 0 4 28h1.5a10.5 10.5 0 1 1 21 0H28a12 12 0 0 0-12-12z"></path>
                                </g>
                            </svg>
                        </div>
                    </div>
                    <div class="data">
                        <div class="fila">
                            <div class="column">
                                <div class="title">
                                    <span>
                                        Nombre
                                    </span>
                                </div>
                                <div class="value">
                                    <span>
                                        {{datos.nombre||datos.apellidos ? datos.nombre+' '+datos.apellidos : '--'}}
                                    </span>
                                </div>
                                <div class="column">
                                    <div class="title">
                                        <span>
                                            Tarifa
                                        </span>
                                    </div>
                                    <div class="value">
                                        <span>
                                            {{datos.tarifa.nombre ? datos.tarifa.nombre : '--'}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="column">
                                <div class="title">
                                    <span>
                                        Teléfono móvil
                                    </span>
                                </div>
                                <div class="value">
                                    <span>
                                        {{datos.movil ? datos.movil : '--'}}
                                    </span>
                                </div>
                                <div class="column">
                                    <div class="title">
                                        <span>
                                            Código postal
                                        </span>
                                    </div>
                                    <div class="value">
                                        <span>
                                            {{datos.codigo_postal ? datos.codigo_postal : '--'}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bp-form-group">
                    <b-button v-b-modal.modal-datos class="alter-btn" @focus.prevent="$event.target.blur()">
                        <span>Modificar</span>
                        <svg class="dx-icon vnrwdl maVQ5M" height="1em" width="1em" focusable="false" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M3 11.3H18L15 8l1-1 5.1 5-5 5-1-1 3.1-3.3H3v-1.4z"></path>
                        </svg>
                    </b-button>
                </div>
            </div>
            <div class="info_divider"></div>
            <div class="info_block">
                <div class="content_area">
                    <div class="icon">
                        <div>
                            <svg width="36" height="37" focusable="false" fill="currentColor" viewBox="0 0 32 32" aria-hidden="true">
                                <path d="M27.3 8H4.6a.8.8 0 0 0-.7.8v14.4a.8.8 0 0 0 .8.8h22.4a.8.8 0 0 0 .8-.8V8.8a.8.8 0 0 0-.8-.8zm-2 1.5L16 17.7 6.7 9.5zm-19.8 13v-12l10 8.8a.7.7 0 0 0 1 0l10-8.8v12z"></path>
                            </svg>
                        </div>
                    </div>
                    <div class="data">
                        <div>
                            <div class="title">
                                <span>
                                    Correo electrónico
                                </span>
                            </div>
                            <div class="value">
                                <span>
                                    {{datos.email ? datos.email : '--'}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bp-form-group">
                    <b-button v-b-modal.modal-email class="alter-btn" @focus.prevent="$event.target.blur()">
                        <span>Modificar</span>
                        <svg class="dx-icon vnrwdl maVQ5M" height="1em" width="1em" focusable="false" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M3 11.3H18L15 8l1-1 5.1 5-5 5-1-1 3.1-3.3H3v-1.4z"></path>
                        </svg>
                    </b-button>
                </div>
            </div>
            <div class="info_divider"></div>
            <div class="info_block">
                <div class="content_area">
                    <div class="icon">
                        <div>
                            <svg width="36" height="37" focusable="false" fill="currentColor" viewBox="0 0 32 32" aria-hidden="true">
                                <path d="M23.1 12H22V8a5.9 5.9 0 0 0-6-5.8A5.9 5.9 0 0 0 10 8V12H8.9A2.8 2.8 0 0 0 6 14.7v10.6A2.8 2.8 0 0 0 8.9 28H23a2.8 2.8 0 0 0 2.9-2.7V14.7a2.8 2.8 0 0 0-2.9-2.7zM17 20.7V23h-2v-2.3a2 2 0 1 1 2 0zm3.5-8.7h-9V8A4.4 4.4 0 0 1 16 3.6 4.4 4.4 0 0 1 20.5 8z"></path>
                            </svg>
                        </div>
                    </div>
                    <div class="data">
                        <div>
                            <div class="title">
                                <span>
                                    Tu contraseña
                                </span>
                            </div>
                            <div class="value">
                                <span>
                                    ***************
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bp-form-group">
                    <b-button v-b-modal.modal-clave class="alter-btn" @focus.prevent="$event.target.blur()">
                        <span>Modificar</span>
                        <svg class="dx-icon vnrwdl maVQ5M" height="1em" width="1em" focusable="false" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M3 11.3H18L15 8l1-1 5.1 5-5 5-1-1 3.1-3.3H3v-1.4z"></path>
                        </svg>
                    </b-button>
                </div>
            </div>
        </div>

        <!-- MODAL DATOS -->
        <b-modal id="modal-datos" ref="modal_datos" title="Datos de usuario" size="lg" hide-footer>

            <form ref="form" @submit="submitDatos">
                <b-form-group label-cols-md="3" label="Nombre" label-for="nombre-input">
                    <b-form-input @input="errors.nombre = ''" id="nombre-input" :class="{ 'is-invalid': errors.nombre }" v-model="datos.nombre" required></b-form-input>
                    <div v-for="error in errors.nombre" class="invalid-feedback">
                        {{ error }}
                    </div>
                </b-form-group>

                <b-form-group label-cols-md="3" label="Apellidos" label-for="apellidos-input">
                    <b-form-input @input="errors.apellidos = ''" id="apellidos-input" :class="{ 'is-invalid': errors.apellidos }" v-model="datos.apellidos" required></b-form-input>
                    <div v-for="error in errors.apellidos" class="invalid-feedback">
                        {{ error }}
                    </div>
                </b-form-group>

                <b-form-group label-cols-md="3" label="Movil" label-for="movil-input">
                    <b-form-input @input="errors.movil = ''" id="movil-input" :class="{ 'is-invalid': errors.movil }" v-model="datos.movil"></b-form-input>
                    <div v-for="error in errors.movil" class="invalid-feedback">
                        {{ error }}
                    </div>
                </b-form-group>

                <b-form-group label-cols-md="3" label="Código postal" label-for="codigo-postal-input">
                    <b-form-input @input="errors.codigo_postal = ''" id="codigo-postal-input" :class="{ 'is-invalid': errors.codigo_postal }" v-model="datos.codigo_postal" required></b-form-input>
                    <div v-for="error in errors.codigo_postal" class="invalid-feedback">
                        {{ error }}
                    </div>
                </b-form-group>

                <!--<b-form-group label-cols-md="3" label="Tarifa" label-for="tarifa_id-input">
                    <b-form-select @input="errors.tarifa_id = ''" id="tarifa_id-input" :class="{ 'is-invalid': errors.tarifa_id }" @change="loadProvincias($event)" v-model="datos.tarifa_id">
                        <option value="" selected>-- Selecciona tarifa --</option>
                        <option v-for="tarifa in tarifas" :value="tarifa.id">{{ tarifa.nombre }}</option>
                    </b-form-select>
                    <div v-for="error in errors.tarifa_id" class="invalid-feedback">
                        {{ error }}
                    </div>
                </b-form-group>-->

                <b-form-group label-cols-md="3" label="Suscribirse al newsletter" label-for="newsletter-input">
                    <b-form-checkbox id="newsletter-input" v-model="datos.newsletter" value="1" unchecked-value="0" switch></b-form-checkbox>
                    <div v-for="error in errors.newsletter" class="invalid-feedback">
                        {{ error }}
                    </div>
                </b-form-group>

                <b-form-group label-cols-md="3" label="Envíos con cajas reutilizadas" label-for="cajas-reutilizadas-input">
                    <b-form-checkbox id="cajas-reutilizadas-input" v-model="datos.cajas_reutilizadas" value="1" unchecked-value="0" switch></b-form-checkbox>
                    <div v-for="error in errors.cajas_reutilizadas" class="invalid-feedback">
                        {{ error }}
                    </div>
                </b-form-group>

                <b-button type="submit" variant="success">Actualizar datos</b-button>
            </form>

        </b-modal>

        <!-- MODAL EMAIL -->
        <b-modal id="modal-email" ref="modal_email" title="Cambiar email" size="lg" hide-footer>

            <div class="_3rpMKM">
                <div class="NYErdr CLl528 mi_SMM _2CFzyb">
                        <span class="A95iT1 _1zUddv nmA88J Q4hn14 Zk780h Sdj0lW" for="current-email">
                            Correo electrónico actual:
                        </span>
                </div>
                <div class="Lj_xuB KDDSxE">
                    <span class="A95iT1 _1zUddv nmA88J NLxqv6 Zk780h dxuc4Q">
                        {{datos.email ? datos.email : '--'}}
                    </span>
                </div>
            </div>

            <form ref="form" @submit="submitEmail">

                <b-form-group label-cols-md="3" label="Nuevo correo electrónico" label-for="email-input">
                    <b-form-input @input="errors.email = ''" id="email-input" :class="{ 'is-invalid': errors.email }" v-model="datos_email.email" required></b-form-input>
                    <div v-for="error in errors.email" class="invalid-feedback">
                        {{ error }}
                    </div>
                </b-form-group>

                <b-form-group label-cols-md="3" label="Confirmar nuevo correo electronico" label-for="email_confirmation-input">
                    <b-form-input @input="errors.email_confirmation = ''" id="confirm_email-input" :class="{ 'is-invalid': errors.email_confirmation }" v-model="datos_email.email_confirmation " required></b-form-input>
                    <div v-for="error in errors.email_confirmation" class="invalid-feedback">
                        {{ error }}
                    </div>
                </b-form-group>

                <b-form-group label-cols-md="3" label="Contraseña" label-for="clave-input">
                    <b-form-input type="password" @input="errors.clave = ''" id="clave-input" :class="{ 'is-invalid': errors.clave }" v-model="datos_email.clave"></b-form-input>
                    <div v-for="error in errors.clave" class="invalid-feedback">
                        {{ error }}
                    </div>
                </b-form-group>

                <b-button type="submit" variant="success">Actualizar datos</b-button>

            </form>

        </b-modal>

        <!-- MODAL CLAVE -->
        <b-modal id="modal-clave" ref="modal_clave" title="Cambiar clave" size="lg" hide-footer>

            <form ref="form" @submit="submitClave">

                <b-form-group label-cols-md="3" label="Contraseña" label-for="clave-input">
                    <b-form-input type="password" @input="errors.clave = ''" id="clave-input" :class="{ 'is-invalid': errors.clave }" v-model="datos_clave.clave"></b-form-input>
                    <div v-for="error in errors.clave" class="invalid-feedback">
                        {{ error }}
                    </div>
                </b-form-group>

                <b-form-group label-cols-md="3" label="Contraseña nueva" label-for="nueva_clave-input">
                    <b-form-input type="password" @input="errors.nueva_clave = ''" id="nueva_clave-input" :class="{ 'is-invalid': errors.nueva_clave }" v-model="datos_clave.nueva_clave" required></b-form-input>
                    <div v-for="error in errors.nueva_clave" class="invalid-feedback">
                        {{ error }}
                    </div>
                </b-form-group>

                <b-form-group label-cols-md="3" label="Confirmar contraseña" label-for="nueva_clave_confirmation-input">
                    <b-form-input type="password" @input="errors.nueva_clave_confirmation = ''" id="nueva_clave_confirmation-input" :class="{ 'is-invalid': errors.nueva_clave_confirmation }" v-model="datos_clave.nueva_clave_confirmation" required></b-form-input>
                    <div v-for="error in errors.nueva_clave_confirmation" class="invalid-feedback">
                        {{ error }}
                    </div>
                </b-form-group>

                <b-button type="submit" variant="success">Actualizar datos</b-button>

            </form>
        </b-modal>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                datos: {
                    nombre: '',
                    apellidos: '',
                    movil: '',
                    codigo_postal: '',
                    tarifa_id: '',
                    newsletter: '',
                    cajas_reutilizadas: '',
                },
                datos_email: {
                    email: '',
                    email_confirmation: '',
                    clave: ''
                },
                datos_clave: {
                    clave: '',
                    nueva_clave: '',
                    nueva_clave_confirmation: ''
                },
                errors: "",
                tarifas: ""
            }
        },
        mounted() {
            this.loadDataClient();
            this.loadTarifas();
        },
        methods: {
            loadDataClient: function () {
                axios.get('/account/get-datos').then(response => {
                    this.datos = response.data.datos;
                }).catch(e => {
                    console.log(e);
                });
            },
            loadTarifas: function () {
                axios.get('/account/get-tarifas').then(response => {
                    this.tarifas = response.data.tarifas;
                }).catch(e => {
                    console.log(e);
                });
            },
            submitDatos(evt) {
                evt.preventDefault();
                axios.put('/account/datos/update/datos',this.datos).then(response => {
                    this.loadDataClient();
                    this.$refs.modal_datos.hide();
                    Vue.toasted.show(response.data.info, {
                        type: "success",
                        duration: 3000
                    });
                }).catch(e => {
                    Vue.toasted.show('Ha habido un error!', {
                        type: "error",
                        duration: 3000
                    });
                    if (e.response.status === 422) {
                        console.log(e.response.status);
                        this.errors = e.response.data.errors;
                    }
                });
            },
            submitEmail(evt) {
                evt.preventDefault();
                axios.put('/account/datos/update/email',this.datos_email).then(response => {
                    this.loadDataClient();
                    this.$refs.modal_email.hide();
                    Vue.toasted.show(response.data.info, {
                        type: "success",
                        duration: 3000
                    });
                }).catch(e => {
                    Vue.toasted.show('Ha habido un error!', {
                        type: "error",
                        duration: 3000
                    });
                    if (e.response.status === 422) {
                        console.log(e.response.status);
                        this.errors = e.response.data.errors;
                    }
                });
            },
            submitClave(evt) {
                evt.preventDefault();
                axios.put('/account/datos/update/clave',this.datos_clave).then(response => {
                    this.loadDataClient();
                    this.$refs.modal_clave.hide();
                    Vue.toasted.show(response.data.info, {
                        type: "success",
                        duration: 3000
                    });
                }).catch(e => {
                    Vue.toasted.show('Ha habido un error!', {
                        type: "error",
                        duration: 3000
                    });
                    if (e.response.status === 422) {
                        console.log(e.response.status);
                        this.errors = e.response.data.errors;
                    }
                });
            },
        }
    }
</script>
